import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';

var withKeyboardEvents = function withKeyboardEvents(Target) {
  return /*#__PURE__*/function (_Component) {
    _inherits(Grid, _Component);

    var _super = _createSuper(Grid);

    function Grid(props, context) {
      var _this;

      _classCallCheck(this, Grid);

      _this = _super.call(this, props, context);
      _this.state = {
        visible: props.visible,
        invertedColor: props.invertedColor,
        selectingTarget: false,
        targetRect: {
          top: 0,
          left: 0,
          width: 0,
          height: 0
        },
        rootRect: {
          top: 0,
          left: 0,
          width: 0,
          height: 0
        }
      };
      _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
      _this.onMouseMove = _this.onMouseMove.bind(_assertThisInitialized(_this));
      _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
      _this.onRef = _this.onRef.bind(_assertThisInitialized(_this));
      _this.rootElement = undefined;
      _this.currentTargetElement = undefined;
      global.addEventListener('keypress', _this.onKeyPress);
      global.addEventListener('mousemove', _this.onMouseMove);
      global.focus && global.focus();
      return _this;
    }

    _createClass(Grid, [{
      key: "onKeyPress",
      value: function onKeyPress(e) {
        if (e.ctrlKey && e.key === 'i') {
          this.setState({
            invertedColor: !this.state.invertedColor
          });
        } else if (e.ctrlKey && e.key === 'g') {
          this.setState({
            visible: !this.state.visible
          });
        } else if (e.ctrlKey && e.key === 's' && this.state.visible) {
          if (this.state.selectingTarget) {
            var _ref = this.currentTargetElement ? this.currentTargetElement.getBoundingClientRect() : {
              top: 0,
              width: 0,
              height: 0,
              left: 0
            },
                top = _ref.top,
                width = _ref.width,
                height = _ref.height,
                left = _ref.left;

            this.setState({
              selectingTarget: false,
              targetRect: {
                top: top,
                left: left,
                width: width,
                height: height
              }
            });
          } else {
            this.setState({
              selectingTarget: true
            });
          }
        }
      }
    }, {
      key: "onMouseMove",
      value: function onMouseMove(e) {
        this.currentTargetElement = e.target;
      }
    }, {
      key: "onRef",
      value: function onRef(domElement) {
        if (domElement) {
          this.rootElement = domElement;

          var _domElement$getBoundi = domElement.getBoundingClientRect(),
              top = _domElement$getBoundi.top,
              width = _domElement$getBoundi.width,
              height = _domElement$getBoundi.height,
              left = _domElement$getBoundi.left;

          this.setState({
            rootRect: {
              top: top,
              left: left,
              width: width,
              height: height
            }
          });
        }
      }
    }, {
      key: "onResize",
      value: function onResize(_ref2) {
        var width = _ref2.width,
            height = _ref2.height;
        this.setState({
          rootRect: _objectSpread(_objectSpread({}, this.state.rootRect), {}, {
            width: width,
            height: height
          })
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        this.setState({
          visible: nextProps.visible != null ? nextProps.visible : this.state.visible,
          invertedColor: nextProps.invertedColor != null ? nextProps.invertedColor : this.state.invertedColor
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        global.removeEventListener('keypress', this.onKeyPress);
        global.removeEventListener('mousemove', this.onMouseMove);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            visible = _this$state.visible,
            invertedColor = _this$state.invertedColor,
            rootRect = _this$state.rootRect,
            selectingTarget = _this$state.selectingTarget,
            targetRect = _this$state.targetRect;
        return /*#__PURE__*/React.createElement(Target, _extends({}, this.props, {
          onRef: this.onRef,
          invertedColor: invertedColor,
          visible: visible,
          selectingTarget: selectingTarget,
          rootRect: rootRect,
          targetRect: targetRect,
          onResize: this.onResize
        }));
      }
    }]);

    return Grid;
  }(Component);
};

export default withKeyboardEvents;
//# sourceMappingURL=withKeyboardEvents.js.map